import {CAPABILITY} from "../../util/Constants";
import {getDisplayName} from "../../util/Util";
import {fetchCPTDetails} from "../network/ReceiveNetworkAPI";

export const ReceiverGroupByReducer = (state, action) => {
    const formattedIdPrefix = "receivergroup."

    function fetchCPTGroups(CPTLabel,filterIdentifier) {
        return [
            {displayName: getDisplayName("None", formattedIdPrefix), value: ""},
            {displayName: getDisplayName("Package Size", formattedIdPrefix), value: "PackageSize"},
            {displayName: getDisplayName("Destination", formattedIdPrefix), value: "StationCode"},
            {displayName: getDisplayName("Station EAD", formattedIdPrefix), value: "EAD"},
            {displayName: getDisplayName(CPTLabel, "CPT."), value: filterIdentifier},
            {displayName: getDisplayName("Cluster", formattedIdPrefix), value: "Cluster"}
        ]
    }

    const defaultCycleGroups = [
        {displayName: getDisplayName("None", formattedIdPrefix), value: ""},
        {displayName: getDisplayName("Package Size", formattedIdPrefix), value: "PackageSize"},
        {displayName: getDisplayName("Destination", formattedIdPrefix), value: "StationCode"},
        {displayName: getDisplayName("Station EAD", formattedIdPrefix), value: "EAD"},
        {displayName: getDisplayName("Cycle", formattedIdPrefix), value: "Cycle"},
        {displayName: getDisplayName("Cluster", formattedIdPrefix), value: "Cluster"}
    ]

    const ArNextGenApplicableGroups = [
        {displayName: getDisplayName("None", formattedIdPrefix), value: ""},
        {displayName: getDisplayName("Package Size", formattedIdPrefix), value: "PackageSize"},
        {displayName: getDisplayName("Station EAD", formattedIdPrefix), value: "EAD"}
    ]

    const getApplicableGroups = (capability) => {
        switch (capability) {
            case CAPABILITY.AR_NEXT_GEN:
                return ArNextGenApplicableGroups
            default:
                return defaultCycleGroups
        }
    }

    const getApplicableGroupsForCPT = (capability,CPTLabel,filterIdentifier) => {
        switch (capability) {
            case CAPABILITY.AR_NEXT_GEN:
                return ArNextGenApplicableGroups
            default:
                return fetchCPTGroups(CPTLabel,filterIdentifier)
        }
    }

    switch (action.type) {
        case "INITIALIZE_GROUPS":
            return {
                ...state,
                allGroups: getApplicableGroups(action.capability)
            }
        case "INITIALIZE_CPT_FILTER_ENABLED_GROUPS":
            return {
                ...state,
                allGroups: getApplicableGroupsForCPT(action.data.capability,action.data.CPTLabel,action.data.filterIdentifier)
            }
        case 'SELECT_GROUP':
            return {
                ...state, selectedGroup: action.selectedGroup
            };
        case 'FETCH_CPT':
            fetchCPTDetails(action.data.dispatcher,action.capability)
            return state
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/components/receive/reducers/ReceiveGroupByReducer.js